import { render, staticRenderFns } from "./wechat-app-config.vue?vue&type=template&id=94efe13e&scoped=true&"
import script from "./wechat-app-config.vue?vue&type=script&lang=js&"
export * from "./wechat-app-config.vue?vue&type=script&lang=js&"
import style0 from "./wechat-app-config.vue?vue&type=style&index=0&id=94efe13e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94efe13e",
  null
  
)

export default component.exports